module.exports = __webpack_public_path__ + "media/images/career_camp/2023/stats_illustration_5-ced8132ffd67d85af1191148b40a0cf5.svg";